import { Component, computed, input } from '@angular/core';
import { GcTextComponent, IpoTranslatePipe } from '@ip-only/front-end-library';
import { RolloutProgressReportEntities } from '../../self-inspection-reports/service/entities';
import { DuctProperties } from '../duct.entities';

@Component({
  selector: 'app-duct-popup-content',
  imports: [GcTextComponent, IpoTranslatePipe],
  templateUrl: './duct-popup-content.component.html',
  styleUrl: './duct-popup-content.component.scss',
})
export class DuctPopupContentComponent {
  multiDuctInformation = input.required<DuctProperties | null>();
  ductInformation = input.required<DuctProperties | null>();
  pointConnectedTo = input<string | null>(null);
  reportStatus = input<
    RolloutProgressReportEntities.v3.ReportStatus | undefined
  >();
  readonly formattedStatus = computed(() => {
    const status = this.reportStatus();
    return status ? this.formatStatus(status) : undefined;
  });

  getMultiDuctName(name: string): string {
    return name.split(' ')[0];
  }

  private formatStatus(
    status: RolloutProgressReportEntities.v3.ReportStatus,
  ): string {
    return status
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, (character) => character.toUpperCase());
  }
}
